<template>
  <div
    class="searchField__wrapper"
    @click="inputRef.focus()"
  >
    <input
      ref="inputRef"
      v-model="input"
      class="searchField__input"
      type="text"
      :placeholder="placeholder"
      v-bind="$attrs"
    >
    <slot />
  </div>
</template>

<script setup>
const inputRef = ref();

const props = defineProps({
	searchTerm: String,
	placeholder: String
});

const input = defineModel('input', {
	type: String,
	default: ''
});

defineExpose({
	focus: () => inputRef.value?.focus()
});

</script>

<style scoped lang="scss">
  .searchField__wrapper {
    padding: 2rem;
    position: relative;
    border-radius: $borderRadius-xs;
    background-color: $color-blue-000;
    width: 100%;
    margin-bottom: 1rem;

    @include breakpoint_down(md) {
      padding: 1rem;
    }
  }

  .searchField__input[type=text] {
    background-color: transparent;
    width: 100%;
  }

</style>
